import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsCompletedPayload } from '../payloads/projectsCompletedPayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildProjectsCompletedInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsCompletedPayload(payload);
  const { projects_completed } = parsedPayload.data.attributes.aggregate;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: projects_completed.current ?? 0,
          trend: projects_completed.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
